module.exports = __webpack_public_path__ + "img/magento-support-security@2x.0ee3479b.webp";